import { createGetterBS, createSetterBS } from '@ocodelib/ex-util/rx';
import type * as monaco from 'monaco-editor';
import { BehaviorSubject } from 'rxjs';
import type { IAppConfig, IPyBasicLayoutConfig, PyBasicAppType } from './types';
import { UiState } from './UiState';

export class PyBasicAppManager {
  private app$ = new BehaviorSubject<PyBasicAppType | null>(null);
  private monacoInstance$ = new BehaviorSubject<typeof monaco | null>(null);

  readonly uiState = new UiState();

  constructor(readonly appConfig: IAppConfig) {
    // empty
  }

  setApp = createSetterBS(this.app$);
  observeApp = createGetterBS(this.app$);

  setMonacoInstance = createSetterBS(this.monacoInstance$);
  observeMonacoInstance = createGetterBS(this.monacoInstance$);

  setup(config: IPyBasicLayoutConfig) {
    this.uiState.updateFromConfig(config);
    if (this.appConfig.previewMode) {
      this.uiState.setPreviewMode(true);
    }
  }
}
